import React  from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PropertyAgentFullPage.css";
//import properties from "./properties.json";
import { SavedRow, PropertyImage, } from "./types";
import { formatPrice, toS3Image, formatDecimalNumber, make_property_id, } from "./Utils";
import { FullPageIndexer } from './FullPageIndexer';
import printer from "./printer.png";
import { ImageCount } from "./ImageCount";
import PropertyAgentFullPageActual from "./PropertyAgentFullPageActual";
import { PropertyAPI } from "./lib/property-api";
import { PropertiesFile } from "./types";
import { get_source } from "./lib/source";
const dd = console.debug;

function daysSince(dateString: string): number {
  const inputDate = new Date(dateString);
  const today = new Date();

  // Set both dates to start of the day to avoid partial day issues
  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - inputDate.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}

function presentMlsStatus(s: string | null) {
  if (!s) {
    return "";
  }
  s = s.toLowerCase();
  if (s === "expired") {
    return <b className="pafp-expired">Expired</b>;
  }
  if (s === "withdrawn") {
    return <b className="pafp-withdrawn">Withdrawn</b>;
  }
  if (s === "sold") {
    return <b className="pafp-sold">Sold</b>;
  }
  if (s === "active" || s === "pending") {
    return <b className="pafp-active">Active</b>;
  }
  return s;
}

function PropertyAgentFullPage() {
  const [data, setData] = React.useState<SavedRow|null>(null);
  const [propertyID, setPropertyID] = React.useState<string>('');
  const [street, setStreet] = React.useState<string>("");
  const [cityStateZip, setCityStateZip] = React.useState<string>("");
  const [stateZip,setStateZip] = React.useState<string>('');
  const [beds, setBeds] = React.useState<number | null>(null);
  const [baths, setBaths] = React.useState<number | null>(null);
  const [fullBaths, setFullBaths] = React.useState<number | null>(null);
  const [halfBaths, setHalfBaths] = React.useState<number | null>(null);
  const [squareFeet, setSquareFeet] = React.useState<string | null>(null);
  const [prettyPrice, setPrettyPrice] = React.useState<string>("");
  const [listingKey, setListingKey] = React.useState<string>("");
  const [mlsStatus, setMlsStatus] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [image, setImage] = React.useState<PropertyImage | null>(null);
  const [propertyType, setPropertyType] = React.useState<string | null>(null);
  const [propertySubType, setPropertySubType] = React.useState<string | null>(
    null
  );
  const [city,setCity] = React.useState<string|null>(null);
  const [unitNumber, setUnitNumber] = React.useState<string | null>(null);
  const [selectThisProperty, setSelectThisProperty] =
    React.useState<boolean>(false);
  const [lotSize, setLotSize] = React.useState<string>("");
  const [yearBuilt, setYearBuilt] = React.useState<number | null>(null);
  const [daysOnMarket, setDaysOnMarket] = React.useState<number>(-1);
  const [publicRemarks,setPublicRemarks] = React.useState<string|null>(null);
  const [fullPageIndexer,_] = React.useState<FullPageIndexer>(new FullPageIndexer());
  const [isChecked,setIsChecked] = React.useState<boolean>(false);
  const [activeListings,setActiveListings] = React.useState<string[]>([]);
  const [showImageGallery,setShowImageGallery] = React.useState<boolean>(false);
  const [imageCount,setImageCount] = React.useState<number>(0);
  const [doPrint,setDoPrint] = React.useState<boolean>(false);
  const [loadingPrintableZone,setLoadingPrintableZone] = React.useState<boolean>(false);
  const [errorMessage,setErrorMessage] = React.useState<string|null>(null);
  //const [properties,setProperties] = React.useState<PropertiesFile|null>(null);
  const [api,__] = React.useState<PropertyAPI>(new PropertyAPI());

  function glob_sanity_check(){
    if(typeof global.lombardo.done_loading === 'undefined'){
      global.lombardo.done_loading = [];
      global.lombardo.needs_loading = [];
    }
  }
  React.useEffect(() => {
    (async () => {
      glob_sanity_check();
      const u: URL = new URL("https://lombardohomesandestates.com/");
      const is_staging: boolean = window.location.pathname.includes("/staging/");
      if (is_staging) {
        u.pathname = "/staging/";
        if(['localhost','0.0.0.0',].includes(window.location.hostname)){
          u.host = window.location.hostname;
          u.port = window.location.port;
          u.protocol = 'http';
        }
      } else {
        u.pathname = "/mls-properties/";
      }
      u.searchParams.set("viewMode", "icons");
      u.searchParams.set("displayMode", "property");
      u.searchParams.set("backDisplayMode", "show-active");
      u.searchParams.set("sortMode", "highest-first");
      //TODO: set this when we find the current index 
      //u.searchParams.set("listing", propertyID);
      //setMlsLink(u);
      if (typeof global.lombardo === "undefined") {
        global.lombardo = {
          selected: [],
        };
      }
      let active_listings: string[] = [];
      let properties: PropertiesFile|null;
      properties = await api.get_active_by_source(get_source());
      console.debug({properties},'<<< PAFP');
      if(properties && Object.keys(properties).length > 0){
        active_listings = Object.keys(properties);
      }
      setActiveListings(active_listings);
      fullPageIndexer.setAllProperties(active_listings);
      setPropertyID(active_listings[0]);
      const img_count: number|null = await ImageCount(active_listings[0]);
      if(img_count === null){
        setImageCount(0);
      }else{
        setImageCount(img_count);
      }
      setDoPrint(false);
    })();
  }, []);
  React.useEffect(() => {
    (async () => {
      dd({propertyID},'<< PropertyAgentFullPage');
      let tmp: SavedRow|null = await api.get_property_by_source(propertyID,get_source());
      setData(tmp);
      console.debug({tmp});
      if (!tmp){
        console.log('!data in Agent Full Page');
        setError("Unable to find the listing you were looking for.");
        return;
      }
      //setPropertyID(tmp.ListingKey);
      setCity(tmp.City);
      setYearBuilt(tmp.YearBuilt);
      setError(null);
      //setGoogleMapsLink(createGoogleMapsLink(properties[propertyID]));
      let media_length: number = 0;
      if (Array.isArray(tmp.Media)) {
        media_length = tmp.Media.length;
      } else {
        media_length = 0;
      }

      const source = get_source();
      if (media_length > 0) {
        let image: PropertyImage | null = null;
        for (const media of tmp.Media) {
          try {
            if (Number(media.Order) === 0) {
              image = toS3Image(media.MediaURL, media.Order,source );
              setImage(image);
              break;
            }
          } catch (err) {}
        }
        if (image === null) {
          for (const media of tmp.Media) {
            try {
              setImage(toS3Image(media.MediaURL, media.Order, source));
              break;
            } catch (err) {}
          }
        }
      }
      if (tmp.ListingKey && String(tmp.ListingKey).match(/^KEY/)) {
        setListingKey(String(tmp.ListingKey).replace(/^KEY/, ""));
      } else {
        setListingKey(tmp.ListingKey);
      }
      if (typeof tmp.MlsStatus !== "undefined") {
        setMlsStatus(tmp.MlsStatus);
      }
      {
        const sqft: string = tmp.LotSizeDimensions;
        setLotSize(sqft);
      }
      if(typeof tmp.LotSizeSquareFeet === 'number'){
        const sqft: string = formatDecimalNumber(tmp.LotSizeSquareFeet);
        if (sqft === "-1") {
          setSquareFeet(null);
        } else {
          setSquareFeet(sqft);
        }
      }else if(tmp.LotSizeSquareFeet === null || typeof tmp.LotSizeSquareFeet === 'string'){
        setSquareFeet(tmp.LotSizeSquareFeet);
      }else{
        setSquareFeet(null);
      }
      if (
        typeof tmp.BathroomsFull === "undefined" ||
        Number(tmp.BathroomsFull) === 0
      ) {
        setBaths(null);
      } else {
        setBaths(tmp.BathroomsFull);
        setFullBaths(tmp.BathroomsFull);
      }
      let half_baths: number = 0;
      if (
        typeof tmp.BathroomsHalf !== "undefined" ||
        Number(tmp.BathroomsHalf) > 0
      ) {
        half_baths = Number(tmp.BathroomsHalf);
        setHalfBaths(half_baths);
      }
      if (
        typeof tmp.BedroomsTotal === "undefined" ||
        Number(tmp.BedroomsTotal) === 0
      ) {
        setBeds(null);
      } else {
        let baths: number = Number(tmp.BedroomsTotal);
        if (half_baths) {
          baths += half_baths;
        }
        setBeds(baths);
      }
      let compiled_street: string[] = [];
      let zip: string|null = null;
      let state: string|null = null;
      if (
        typeof tmp.StreetNumber !== "undefined" &&
        String(tmp.StreetNumber) !== "undefined"
      ) {
        compiled_street.push(String(tmp.StreetNumber));
      }
      if (
        typeof tmp?.StreetName !== "undefined" &&
        String(tmp.StreetName) !== "undefined"
      ) {
        compiled_street.push(String(tmp.StreetName));
      }
      if (
        typeof tmp?.StreetSuffix !== "undefined" &&
        String(tmp.StreetSuffix) !== "undefined"
      ) {
        compiled_street.push(String(tmp.StreetSuffix));
      }
      setStreet(compiled_street.join(" "));
      let compiled_state: string[] = [];
      if (
        typeof tmp.PostalCity !== "undefined" &&
        String(tmp.PostalCity) !== "undefined"
      ) {
        compiled_state.push(String(tmp.PostalCity));
      }
      if (
        typeof tmp.StateOrProvince !== "undefined" &&
        String(tmp.StateOrProvince) !== "undefined"
      ) {
        compiled_state.push(String(tmp.StateOrProvince));
        state = String(tmp.StateOrProvince);
      }
      if (
        typeof tmp.PostalCode !== "undefined" &&
        String(tmp.PostalCode) !== "undefined"
      ) {
        compiled_state.push(String(tmp.PostalCode));
        zip = String(tmp.PostalCode);
      }
      setStateZip([state,zip].join("/"));
      setCityStateZip(compiled_state.join(" "));
      setPrettyPrice(formatPrice(tmp.ListPrice));
      setPropertyType(tmp.PropertyType);
      setPropertySubType(tmp.PropertySubType);
      let unit_number: string | null = null;
      if (typeof tmp.UnitNumber !== "undefined" && tmp.UnitNumber !== null) {
        unit_number = tmp.UnitNumber;
      }
      setUnitNumber(unit_number);
      if (
        tmp.OnMarketDate !== null &&
        String(tmp.OnMarketDate).match(/^\d{4}-\d{2}-\d{2}$/)
      ) {
        setDaysOnMarket(daysSince(String(tmp.OnMarketDate)));
      }
      setPublicRemarks(tmp.PublicRemarks);
      setIsChecked(fullPageIndexer.isSelected(propertyID));
      setImageCount(tmp.Media.length);
      //const img_count: number|null = await ImageCount(propertyID);
      //if(img_count === null){
      //  setImageCount(0);
      //}else{
      //  setImageCount(img_count);
      //}
    })();
  }, [/*data,*/ propertyID, error,doPrint,]);
  function dissipateErrorMessage(){
    window.setTimeout(() => {
      setErrorMessage(null);
    },5000);
  }
  return (
    <div className="PropertyAgentFullPage pafp-font">
      <section className="pafp-selectable-section no-print">
        <div className="pslh-share-interface-wrapper no-print">
          <div
            className={
              "share-modal-buttons "
            }
          >
            <>
              <button className="share-button-generic pslh-share" onClick={() => {
                if(doPrint && loadingPrintableZone){
                  return;
                }
                if(fullPageIndexer.getSelectedProperties().length === 0){
                  setErrorMessage("You must select atleast one property");
                  dissipateErrorMessage();
                  return;
                }
                global.lombardo.needs_loading = fullPageIndexer.getSelectedProperties();
                global.lombardo.done_loading = [];
                setDoPrint(true);
                setLoadingPrintableZone(true);
                const interval = window.setInterval(() => {
                  const ele = document.getElementById('pafp-loading-dock');
                  if(ele){
                    ele.innerText = `Loaded ${global.lombardo.done_loading.length}/${global.lombardo.needs_loading.length} properties...`;
                  }
                  if(global.lombardo.needs_loading.length <= global.lombardo.done_loading.length){
                    window.clearInterval(interval);
                    window.print();
                    setLoadingPrintableZone(false);
                    setDoPrint(false);
                    return;
                  }
                }, 1_000);
              }}>
                <img src={printer} className="share-button-copy-icon"/>
                {loadingPrintableZone === true && (<h1 id="pafp-loading-dock"></h1>)}
                {loadingPrintableZone === false && (<>Print</>)}
              </button>
            </>
          </div>
          <div className="pafp-error-message">
            {errorMessage !== null && (<b>{errorMessage}</b>)}
          </div>
        </div>
        {loadingPrintableZone === false && (<>
          <div>
            <button className="pafp-mass-select" onClick={() => {
              setErrorMessage(null);
              const backup = activeListings;
              setActiveListings([]);
              fullPageIndexer.deselectAll();
              global.lombardo.done_loading = [];
              window.setTimeout(() => {
                setActiveListings(backup);
              },0);
            }}>Select None</button>
            <button className="pafp-mass-select" onClick={() => {
              setErrorMessage(null);
              const backup = activeListings;
              setActiveListings([]);
              fullPageIndexer.selectAll();
              global.lombardo.done_loading = [];
              window.setTimeout(() => {
                setActiveListings(backup);
              },0);
            }}>Select All</button>
          </div>
          <div>
            {activeListings.length > 0 && activeListings.map((value: string,index: number) => {
              return (<button className={"pafp-pager-btn " + (fullPageIndexer.isSelected(value) ? "pafp-pager-btn-selected" : "") + (propertyID === value ? " pafp-pager-btn-active" : "")} onClick={() => {
                setErrorMessage(null);
                setPropertyID(activeListings[index]);
              }}>{index + 1}</button>);
            })}
          </div>
        </>)}
      </section>
      {loadingPrintableZone === false && doPrint === false && (
        <div className={"pafp-presentation " + (doPrint ? "pafp-hidden" : "pafp-show")}>
          <section className="pafp-header-info pafp-border-bottom">
            <div className="pafp-checkbox-header">
              <input className="pafp-checkbox" type="checkbox" checked={isChecked} data-afpid={propertyID} onClick={() => {
                global.lombardo.done_loading = [];
                if(isChecked){
                  setIsChecked(false);
                  fullPageIndexer.deselectProperty(propertyID);
                  return;
                }
                fullPageIndexer.selectProperty(propertyID);
                setIsChecked(true);
              }}/>
              <b className="pafp-street">{street}{unitNumber !== null ? ` #${unitNumber}` : ""}{", "}{cityStateZip}</b>
            </div>
            <div className="pafp-checkbox-header pafp-spaced-out">
              <table className="pafp-hdr-table">
                <tbody>
                  <tr>
                    <td className="pafp-hdr-label">MLS#:</td>
                    <td className="pafp-hdr-value">{make_property_id(propertyID)}</td>
                    <td className="pafp-hdr-label">Prop Type:</td>
                    <td className="pafp-hdr-value">{propertyType}</td>
                    <td className="pafp-hdr-label-slim">Price:</td>
                    <td className="pafp-hdr-value-slim">{prettyPrice}</td>
                  </tr>
                  <tr>
                    <td className="pafp-hdr-label">Status:</td>
                    <td className="pafp-hdr-value">{presentMlsStatus(mlsStatus)}</td>
                    <td className="pafp-pd-label">Sub Type:</td>
                    <td className="pafp-pd-value prop-sub-type">{Array.isArray(propertySubType) && (propertySubType.join(','))}
                      {Array.isArray(propertySubType) === false && (propertySubType)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <PropertyAgentFullPageActual property_id={propertyID} do_print={false} done_loading={() => {
            }}/>
        </div>
      )}
      {doPrint === true && (
        <div className="pafp-print-screen">
          {fullPageIndexer.getSelectedProperties().map((property_id: string) => {
            return (
              <PropertyAgentFullPageActual property_id={property_id} do_print={true} done_loading={() => {
                const prop_id = property_id;
                console.info(`Property fully loaded for printing: ${prop_id}`);
                global.lombardo.done_loading.push(prop_id);
                }}/>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default PropertyAgentFullPage;
